(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xblanks-product-presentation"] && !Shopify.designMode) return;
  try {
    (() => {
  const registrationKey = Symbol.for('xblanks.productColors');
  if (document[registrationKey]) return;
  document[registrationKey] = true;

  const updateColors = (info, size) => {
    const nav = info?.querySelector('.xb-product-colors');
    if (!nav || !size) return;
    nav.querySelectorAll('a[data-color-variants]').forEach((link) => {
      try {
        const variants = JSON.parse(link.dataset.colorVariants);
        link.href = Object.hasOwn(variants, size) ? variants[size] : link.dataset.productUrl;
      } catch {
        link.href = link.dataset.productUrl;
      }
    });
  };

  document.addEventListener('variant:change', (event) => {
    const info = event.target instanceof Element ? event.target.closest('.product-info') : null;
    updateColors(info, event.detail?.variant?.title);
  });

  document.addEventListener('change', (event) => {
    if (!(event.target instanceof Element) || !event.target.matches('input[name="globo-option-0"]')) return;
    updateColors(event.target.closest('.product-info'), event.target.closest('li.select-option[data-value]')?.dataset.value);
  }, true);

  document.addEventListener('click', (event) => {
    const link = event.target instanceof Element ? event.target.closest('.xb-product-colors a') : null;
    if (!link) return;
    const info = link.closest('.product-info');
    const selected = info?.querySelector('input[name="globo-option-0"]:checked');
    updateColors(info, selected?.closest('li.select-option[data-value]')?.dataset.value);
  }, true);
})();
  } catch(e) { console.error(e); }
})();

})();
